import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import Layout from '../components/Layout'
import MateriaisList from '../components/MateriaisList'
import MateriaisSpotlight from '../components/MateriaisSpotlight'

export const MateriaisPage = props => {
  const { data } = props
  const { edges: Materiais } = data.allWpMaterial

  return (
    <Layout>
      <MateriaisSpotlight />
      <MateriaisList materiais={Materiais} title="Materiais" />
    </Layout>
  )
}

MateriaisPage.propTypes = {
  data: PropTypes.shape({
    allWpMaterial: PropTypes.shape({
      edges: PropTypes.array,
    }),
  }),
  pageContext: PropTypes.shape({
    currentPage: PropTypes.number,
    numPages: PropTypes.number,
  }),
}

export default MateriaisPage

export const pageQuery = graphql`
  query MateriaisQuery($limit: Int!, $skip: Int!) {
    allWpMaterial(
      sort: { fields: date, order: DESC }
      limit: $limit
      skip: $skip
    ) {
      edges {
        node {
          excerpt
          id
          title
          materiaisEducativos {
            data
            fieldGroupName
            link
            tipo
            imagemDestaque {
              sourceUrl
            }
          }
        }
      }
    }
  }
`
